import { Box, Button, Typography } from '@mui/material';
import LockRounded from '@mui/icons-material/LockRounded';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppStore';
import { seccionOculta, NOMBRE_SECCION } from '../../lib/restricciones';

/**
 * Admin restringido (lib/restricciones.ts): si entra por URL a una sección que tiene
 * oculta, la pantalla no se arma. El backend igual le rechaza la API; esto evita que vea
 * una pantalla rota llena de errores.
 */
export function SeccionGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const secciones = useAppSelector((s) => s.auth.user?.seccionesOcultas);
  const seccion = seccionOculta(secciones, pathname);
  if (!seccion) return <>{children}</>;
  return (
    <Box sx={{ py: 10, textAlign: 'center' }}>
      <LockRounded sx={{ fontSize: 44, color: 'text.disabled', mb: 1.5 }} />
      <Typography variant="h6" fontWeight={800}>{NOMBRE_SECCION[seccion]} no está habilitado para tu usuario</Typography>
      <Typography color="text.secondary" sx={{ mt: 0.5, mb: 2.5 }}>Si lo necesitás, pedíselo al administrador.</Typography>
      <Button component={RouterLink} to="/" variant="outlined">Volver al inicio</Button>
    </Box>
  );
}
